define('views/modules/conversation/lists/conversation-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // events
    'services/events/conversation-events',
    // models
    'models/member/profile',
    'models/conversation/message',
    // views
    'views/parts/media-info-box',
    'views/modules/supervisor/supervisor-icon',
    // templates
    'text!templates/modules/conversation/lists/conversation-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // events
    ConversationEvents,
    // models
    MProfile,
    MMessage,
    // views
    VMediaInfoBox,
    VSupervisorIcon,
    // templates
    TConversationListItem
) {

    var VConversationListItem = Backbone.Epoxy.View.extend({
        template: TConversationListItem,

        initialize: function(opt) {
            opt = this.options = opt || {};

            var model = this.model,
                view = this.view = {
                    infobox: new VMediaInfoBox({
                        photo: true,
                        model: model,
                        context: this,
                        onClick: this.onClick,
                        menu: {
                            init: this.onMenuInit,
                            onClick: this.onActionClick,
                        },
                        extraPhotoContent: true
                    }),
                };

            _.extend(this, {
                message: new MMessage(model.getLastMessage()),
                profile: opt.profile,
                supervisors: opt.supervisors
            });

            this.listenTo(model, { 'remove': this.remove });
            this.listenTo(Backbone.history, "route", this.onRoute);
        },

        render: function(hiddenDelay) {
            var view = this.view,
                zone = this.zone;

            this.assign(view.infobox, this.$el)
                .setActive();

            this.setInfoboxContent();

            return this;
        },

        setActive: function(val) {
            if (_.isUndefined(val)) {
                val = this.isReferencedInUrl();
            }
            this.view.infobox.setActive(val);
            return this;
        },

        setInfoboxContent: function() {
            var user = this.model.getUser(),
                view = this.view;

            view.infobox.setPhoto(user.get('thumbnail'));
            view.infobox.setContent(Mustache.render(this.template, {
                name: this.model.getDisplayName(),
                message: this.message.get('message') === null || this.message.get('message') === '' ? '' : U.stripHtmlTags(this.message.get('message'))
            }, {
                date: this.getTemplatedTimestamp()
            }));

            if (this.supervisors.get(user)) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                view.infobox.setExtraPhotoContent(supervisorIcon.render().el);
            }
        },

        getTemplatedTimestamp: function() {
            var timestamp = this.message.getTimeStampObject();
            return Mustache.render('<span title="{{timestamp}}">{{fromNow}}</span>', {
                fromNow: timestamp.fromNow(),
                timestamp: timestamp.local()
            });
        },

        deleteConversation: function(result) {
            if (!result) return;
            this.model.destroy();
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },

        isReferencedInUrl: function() {
            return Backbone.history.getFragment().indexOf(this.model.id) > -1;
        },

        ////////////
        // events //
        ////////////

        onRoute: function(router, route, params) {
            this.setActive();
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onMenuInit: function() {
            var menuCollection = new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDelete }
            ]);

            if (this.model.isRead()) {
                menuCollection.add({ caption: 'messages:mark-as-unread', icon: "sl-icon-envelope", callback: this.onMarkUnread });
            } else {
                menuCollection.add({ caption: 'messages:mark-as-read', icon: "sl-icon-envelope-open", callback: this.onMarkRead });
            }

            return menuCollection;
        },

        onMarkUnread: function() {
            var self = this
            this.model.markAsUnread({
                success: function() {
                    self.$el.addClass('unread');
                    ConversationEvents.markedAsReadOrUnread();
                    self.view.infobox.view.menu.collection.remove(self.view.infobox.view.menu.collection.at(1))
                    self.view.infobox.view.menu.collection.push({ caption: 'messages:mark-as-read', icon: "sl-icon-envelope-open", callback: self.onMarkRead })
                }
            })
        },

        onMarkRead: function() {
            var self = this
            this.model.markAsRead({
                success: function() {
                    self.$el.removeClass('unread');
                    ConversationEvents.markedAsReadOrUnread();
                    self.view.infobox.view.menu.collection.remove(self.view.infobox.view.menu.collection.at(1))
                    self.view.infobox.view.menu.collection.push({ caption: 'messages:mark-as-unread', icon: "sl-icon-envelope", callback: self.onMarkUnread })
                }
            })
        },

        onDelete: function() {
            Bootbox.confirm({
                title: i18n.t("conversation:Delete conversation"),
                message: i18n.t("messages:message-delete-conversation"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteConversation,
                context: this,
            });
        },

        onClick: function(e) {
            this.model.trigger("conversation:select", this.model, this.model.getUser());
        },

    });

    return VConversationListItem;
});

